module.exports = __webpack_public_path__ + "img/blocked-grey.06d7b60e.svg";